module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [(_vm.booking_item != null && _vm.participant != null && _vm.package != null) ? _c('div', {
    staticClass: "form quick-form"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.package.price_per == 'week') ? _c('full-week', {
    attrs: {
      "participant": _vm.participant,
      "bookingItem": _vm.booking_item,
      "package": _vm.package
    }
  }) : (_vm.$root.config.use_short_weeks) ? _c('short-weeks', {
    attrs: {
      "participant": _vm.participant,
      "bookingItem": _vm.booking_item,
      "package": _vm.package
    }
  }) : _c('individual-days', {
    attrs: {
      "participant": _vm.participant,
      "bookingItem": _vm.booking_item,
      "package": _vm.package
    }
  })], 1)]) : _c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12"
  }, [_vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-5x dark"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a681434"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/QuickAdd/QuickEdit.vue
// module id = 168
// module chunks = 0